<template>
  <GlobalDialog
    :titleCenter="false"
    dialogDefaultSize="55%"
    v-model="showDialog"
    title=""
    :showClose="false"
    :showActionButton="false"
    forceClose
    :onCancel="close"
  >
    <template #content>
      <div
        class="relative text-left overflow-hidden transform transition-all w-full"
      >
        <div
          class="flex items-start justify-between gap-4 pb-4 border-b border-untitled-gray-100"
        >
          <div class="flex items-start gap-3">
            <div
              class="flex items-center justify-center w-12 h-12 rounded-xl bg-app-primary/10 text-app-primary shrink-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.02-.397-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.28z"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                />
              </svg>
            </div>
            <div>
              <h3 class="text-base font-semibold text-untitled-gray-900">
                Your Certificates
              </h3>
              <p class="text-sm text-untitled-gray-500 mt-0.5">
                Download or resend any certificate you've earned.
              </p>
            </div>
          </div>
          <button
            type="button"
            @click="showDialog = false"
            class="shrink-0 text-untitled-gray-400 hover:text-untitled-gray-600 transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div
          class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 py-4 border-b border-untitled-gray-100"
        >
          <p class="text-sm text-untitled-gray-500">
            <span class="font-semibold text-untitled-gray-700">{{
              filteredCourseList.length +
              filteredModuleList.length +
              filteredPlaylists.length
            }}</span>
            certificate<span
              v-if="
                filteredCourseList.length +
                  filteredModuleList.length +
                  filteredPlaylists.length !==
                1
              "
              >s</span
            >
            earned
          </p>
          <div class="flex items-center gap-2 w-full sm:w-auto">
            <label
              class="text-xs font-medium text-untitled-gray-500 whitespace-nowrap"
              >Sort by</label
            >
            <div class="w-full sm:w-[190px]">
              <ECombobox
                v-model="sortBy"
                name="sorts"
                :options="sorts"
                option-name="name"
                value-key="value"
                placeholder="Sort By"
                :multiple="false"
                :filterable="false"
                :clearable="false"
              />
            </div>
          </div>
        </div>
        <div class="pt-4">
          <div class="w-full">
            <ul
              class="flex list-none flex-wrap gap-1 py-1 mb-3 flex-row bg-untitled-gray-100 rounded-lg p-1 w-full"
            >
              <li class="flex-auto text-center">
                <a
                  class="flex items-center justify-center gap-1.5 text-xs font-semibold px-4 py-2 rounded-md leading-normal cursor-pointer transition-colors"
                  @click="toggleTabs(1)"
                  :class="{
                    'text-untitled-gray-500 hover:text-untitled-gray-700':
                      openTab !== 1,
                    'text-app-primary bg-white shadow-sm': openTab === 1,
                  }"
                >
                  Courses
                  <span
                    v-if="filteredCourseList.length >= 0"
                    class="text-untitled-gray-400"
                    >({{ filteredCourseList.length }})</span
                  >
                </a>
              </li>
              <li class="flex-auto text-center">
                <a
                  class="flex items-center justify-center gap-1.5 text-xs font-semibold px-4 py-2 rounded-md leading-normal cursor-pointer transition-colors"
                  @click="toggleTabs(2)"
                  :class="{
                    'text-untitled-gray-500 hover:text-untitled-gray-700':
                      openTab !== 2,
                    'text-app-primary bg-white shadow-sm': openTab === 2,
                  }"
                >
                  Modules
                  <span
                    v-if="filteredModuleList.length >= 0"
                    class="text-untitled-gray-400"
                    >({{ filteredModuleList.length }})</span
                  >
                </a>
              </li>
              <li class="flex-auto text-center">
                <a
                  class="flex items-center justify-center gap-1.5 text-xs font-semibold px-4 py-2 rounded-md leading-normal cursor-pointer transition-colors"
                  @click="toggleTabs(3)"
                  :class="{
                    'text-untitled-gray-500 hover:text-untitled-gray-700':
                      openTab !== 3,
                    'text-app-primary bg-white shadow-sm': openTab === 3,
                  }"
                >
                  Playlist
                  <span
                    v-if="filteredPlaylists.length >= 0"
                    class="text-untitled-gray-400"
                    >({{ filteredPlaylists.length }})</span
                  >
                </a>
              </li>
            </ul>
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded z-0"
            >
              <div class="flex-auto">
                <div class="tab-content tab-space">
                  <div
                    :class="{
                      hidden: openTab !== 1,
                      block: openTab === 1,
                    }"
                  >
                    <LoadingState v-if="loading" class="mx-auto text-center" />
                    <div v-else>
                      <ul
                        v-if="filteredCourseList.length > 0"
                        role="list"
                        class="overflow-auto flex flex-col gap-3"
                        :style="
                          filteredCourseList.length < 4
                            ? 'height:auto'
                            : 'height: 600px;'
                        "
                      >
                        <li
                          class="flex flex-col gap-3 p-4 rounded-lg border border-untitled-gray-200 hover:border-untitled-gray-300 hover:shadow-sm transition-all bg-white"
                          v-for="course in filteredCourseList"
                          :key="course.id"
                        >
                          <div
                            class="flex flex-col sm:flex-row sm:items-start gap-3"
                          >
                            <div
                              class="flex items-center justify-center w-9 h-9 rounded-full bg-app-primary/10 text-app-primary shrink-0"
                            >
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                                class="w-4 h-4"
                              >
                                <path
                                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            </div>

                            <div class="flex-1 min-w-0">
                              <h4 class="text-sm max-w-full">
                                <a
                                  href="#"
                                  class="font-semibold text-untitled-gray-800 hover:text-app-primary transition-colors"
                                  >{{ course.certificateable?.name }}</a
                                >
                              </h4>
                              <p class="text-xs text-untitled-gray-400 mt-0.5">
                                Certified on
                                {{ formatDate(course.created_at) }}
                              </p>
                            </div>

                            <div class="flex items-center gap-2 shrink-0">
                              <button
                                @click="
                                  downloadCertificate(course.id, 'course')
                                "
                                type="button"
                                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-white bg-app-primary hover:bg-app-secondary transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-3 h-3"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                                  />
                                </svg>
                                Certificate
                              </button>
                              <v-button
                                @click="
                                  resend(
                                    course.certificateable_id,
                                    'course',
                                    course.created_at
                                  )
                                "
                                type="button"
                                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-untitled-gray-700 bg-white border border-untitled-gray-300 hover:bg-untitled-gray-50 transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-3 h-3"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
                                  />
                                </svg>
                                Resend
                              </v-button>
                            </div>
                          </div>

                          <div
                            v-if="course.certificateable?.first_unit?.id"
                            class="pt-3 border-t border-untitled-gray-100"
                          >
                            <p
                              @click="
                                gotoUnit(course.certificateable.first_unit.id)
                              "
                              class="cursor-pointer inline-flex items-center gap-1.5 text-sm font-medium text-app-primary hover:text-app-secondary transition-colors"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-3.5 h-3.5"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                                />
                              </svg>
                              Open Course
                            </p>
                          </div>
                        </li>
                      </ul>
                      <div
                        v-else
                        class="flex flex-col items-center justify-center py-12 text-untitled-gray-400"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.5"
                          class="w-10 h-10"
                        >
                          <path
                            d="M3 7l2-4h14l2 4M3 7v11a2 2 0 002 2h14a2 2 0 002-2V7M3 7h18M9 11h6"
                          />
                        </svg>
                        <p
                          class="mt-3 text-sm font-medium text-untitled-gray-500"
                        >
                          No course certification.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    :class="{
                      hidden: openTab !== 2,
                      block: openTab === 2,
                    }"
                  >
                    <LoadingState v-if="loading" class="mx-auto text-center" />
                    <div v-else>
                      <ul
                        role="list"
                        v-if="filteredModuleList.length > 0"
                        class="overflow-auto flex flex-col gap-3"
                        :style="
                          filteredModuleList.length < 4
                            ? 'height:auto'
                            : 'height: 600px;'
                        "
                      >
                        <li
                          class="flex flex-col gap-3 p-4 rounded-lg border border-untitled-gray-200 hover:border-untitled-gray-300 hover:shadow-sm transition-all bg-white"
                          v-for="data in filteredModuleList"
                          :key="data.id"
                        >
                          <div
                            class="flex flex-col sm:flex-row sm:items-start gap-3"
                          >
                            <div
                              class="flex items-center justify-center w-9 h-9 rounded-full bg-app-primary/10 text-app-primary shrink-0"
                            >
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                                class="w-4 h-4"
                              >
                                <path
                                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            </div>

                            <div class="flex-1 min-w-0">
                              <h4
                                class="text-sm max-w-full"
                                v-if="data.certificateable"
                              >
                                <a
                                  href="#"
                                  class="font-semibold text-untitled-gray-800 hover:text-app-primary transition-colors"
                                  >{{ data.certificateable?.name }}</a
                                >
                              </h4>
                              <p class="text-xs text-untitled-gray-400 mt-0.5">
                                Certified on {{ formatDate(data.created_at) }}
                              </p>
                            </div>

                            <div class="flex items-center gap-2 shrink-0">
                              <button
                                @click="downloadCertificate(data.id, 'module')"
                                type="button"
                                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-white bg-app-primary hover:bg-app-secondary transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-3 h-3"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                                  />
                                </svg>
                                Certificate
                              </button>
                              <v-button
                                @click="
                                  resend(
                                    data.certificateable_id,
                                    'module',
                                    data.created_at
                                  )
                                "
                                type="button"
                                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-untitled-gray-700 bg-white border border-untitled-gray-300 hover:bg-untitled-gray-50 transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-3 h-3"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
                                  />
                                </svg>
                                Resend
                              </v-button>
                            </div>
                          </div>

                          <div
                            v-if="data.certificateable?.first_unit?.id"
                            class="pt-3 border-t border-untitled-gray-100"
                          >
                            <p
                              @click="
                                gotoUnit(data.certificateable?.first_unit?.id)
                              "
                              class="cursor-pointer inline-flex items-center gap-1.5 text-sm font-medium text-app-primary hover:text-app-secondary transition-colors"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-3.5 h-3.5"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                                />
                              </svg>
                              Open Module
                            </p>
                          </div>
                        </li>
                      </ul>
                      <div
                        v-else
                        class="flex flex-col items-center justify-center py-12 text-untitled-gray-400"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.5"
                          class="w-10 h-10"
                        >
                          <path
                            d="M3 7l2-4h14l2 4M3 7v11a2 2 0 002 2h14a2 2 0 002-2V7M3 7h18M9 11h6"
                          />
                        </svg>
                        <p
                          class="mt-3 text-sm font-medium text-untitled-gray-500"
                        >
                          No module certification.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    :class="{
                      hidden: openTab !== 3,
                      block: openTab === 3,
                    }"
                  >
                    <LoadingState v-if="loading" class="mx-auto text-center" />
                    <div v-else>
                      <ul
                        v-if="filteredPlaylists.length > 0"
                        role="list"
                        class="overflow-auto flex flex-col gap-3"
                        :style="
                          filteredPlaylists.length < 4
                            ? 'height:auto'
                            : 'height: 600px;'
                        "
                      >
                        <li
                          class="flex flex-col gap-3 p-4 rounded-lg border border-untitled-gray-200 hover:border-untitled-gray-300 hover:shadow-sm transition-all bg-white"
                          v-for="data in filteredPlaylists"
                          :key="data.id"
                        >
                          <div
                            class="flex flex-col sm:flex-row sm:items-start gap-3"
                          >
                            <div
                              class="flex items-center justify-center w-9 h-9 rounded-full bg-app-primary/10 text-app-primary shrink-0"
                            >
                              <svg
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="1.5"
                                class="w-4 h-4"
                              >
                                <path
                                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            </div>

                            <div class="flex-1 min-w-0">
                              <h4 class="text-sm max-w-full">
                                <a
                                  href="#"
                                  class="font-semibold text-untitled-gray-800 hover:text-app-primary transition-colors"
                                  >{{ data.certificateable?.name }}</a
                                >
                              </h4>
                              <p class="text-xs text-untitled-gray-400 mt-0.5">
                                Certified on {{ formatDate(data.created_at) }}
                              </p>
                            </div>

                            <div class="flex items-center gap-2 shrink-0">
                              <button
                                @click="
                                  downloadCertificate(data.id, 'playlist')
                                "
                                type="button"
                                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-white bg-app-primary hover:bg-app-secondary transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-3 h-3"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                                  />
                                </svg>
                                Certificate
                              </button>

                              <v-button
                                @click="
                                  resend(
                                    data.certificateable_id,
                                    'playlist',
                                    data.created_at
                                  )
                                "
                                type="button"
                                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-untitled-gray-700 bg-white border border-untitled-gray-300 hover:bg-untitled-gray-50 transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-3 h-3"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
                                  />
                                </svg>
                                Resend
                              </v-button>
                            </div>
                          </div>

                          <div
                            v-if="data.certificateable?.first_unit?.id"
                            class="pt-3 border-t border-untitled-gray-100"
                          >
                            <p
                              @click="
                                gotoUnit(
                                  data.certificateable?.first_unit?.id,
                                  data.certificateable_id
                                )
                              "
                              class="cursor-pointer inline-flex items-center gap-1.5 text-sm font-medium text-app-primary hover:text-app-secondary transition-colors"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke-width="1.5"
                                stroke="currentColor"
                                class="w-3.5 h-3.5"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                                />
                              </svg>
                              Open Playlist
                            </p>
                          </div>
                        </li>
                      </ul>
                      <div
                        v-else
                        class="flex flex-col items-center justify-center py-12 text-untitled-gray-400"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.5"
                          class="w-10 h-10"
                        >
                          <path
                            d="M3 7l2-4h14l2 4M3 7v11a2 2 0 002 2h14a2 2 0 002-2V7M3 7h18M9 11h6"
                          />
                        </svg>
                        <p
                          class="mt-3 text-sm font-medium text-untitled-gray-500"
                        >
                          No playlist certification.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </GlobalDialog>
  <NotificationDialog
    v-if="showNotificationDialog"
    @close="closeNotificationDialog"
    :close-dialog="showNotificationDialog"
    :content="'Successfully resend certificates'"
  />

  <NotificationDialog
    v-if="resending"
    @close="closeNotificationDialog"
    :close-dialog="showNotificationDialog"
    :content="'Resending certificates'"
  />
</template>

<script setup>
import {
  ref,
  inject,
  computed,
  defineEmits,
  watch,
  defineProps,
  onMounted,
} from "vue";
import LoadingState from "@/components/partials/LoadingState.vue";
import NotificationDialog from "@/components/partials/NotificationDialog.vue";
import { useRouter } from "vue-router";
import Bugsnag from "@bugsnag/js";
import { VButton } from "revdojo-vue-components";
import ECombobox from "@/components/element-components/ECombobox";
import formatDate from "@/composable/formatDate";
import { useAuthStore } from "@/stores";
import GlobalDialog from "@/components/layout/GlobalDialog.vue";
import eventBus from "@/plugins/eventBus";

const props = defineProps({
  user: {
    type: Object,
    default: null,
  },
  modelValue: {
    type: Boolean,
    default: false,
    required: true,
  },
});

const openTab = ref(1);
const axios = inject("axios");
const emit = defineEmits(["close", "update:modelValue"]);
const router = useRouter();
const showNotificationDialog = ref(false);
const resending = ref(false);
const loading = ref(false);
const auth = useAuthStore();
const showDialog = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});

const courses = ref([]);
const modules = ref([]);
const playlists = ref([]);

const sortBy = ref(null);
const sorts = ref([
  {
    name: "A-Z",
    value: "a-z",
  },
  {
    name: "Z-A",
    value: "z-a",
  },
  {
    name: "Newest to Oldest",
    value: "newest",
  },
  {
    name: "Oldest to Newest",
    value: "oldest",
  },
]);

function changeSort(sortBy) {
  switch (openTab.value) {
    case 1:
      sorting(courses.value, sortBy);
      break;
    case 2:
      sorting(modules.value, sortBy);
      break;
    case 3:
      sorting(playlists.value, sortBy);
      break;
  }
}

watch(sortBy, (val) => {
  changeSort(val);
});

watch(openTab, () => {
  changeSort(sortBy.value);
});

const sorting = (contents, sortBy) => {
  const sortData = ref(contents);
  sortData.value.sort((a, b) => {
    switch (sortBy) {
      case "default":
        return new Date(b.created_at) - new Date(a.created_at);
      case "a-z":
        return a.certificateable?.name.localeCompare(b.certificateable?.name);
      case "z-a":
        return b.certificateable?.name.localeCompare(a.certificateable?.name);
      case "newest":
        return new Date(b.created_at) - new Date(a.created_at);
      case "oldest":
        return new Date(a.created_at) - new Date(b.created_at);
    }
  });

  switch (openTab.value) {
    case 1:
      filteredCourseList.value = sortData.value;
      break;
    case 2:
      filteredModuleList.value = sortData.value;
      break;
    case 3:
      playlists.value = sortData.value;
      break;
  }
};

const filteredCourseList = computed(() => {
  return courses.value ?? [];
});

const filteredModuleList = computed(() => {
  return modules.value ?? [];
});

const filteredPlaylists = computed(() => {
  return playlists.value ?? [];
});

function toggleTabs(tab) {
  openTab.value = tab;
}

const sendCertificate = async (id, type) => {
  await axios
    .post(`/api/download/certificate`, {
      userId: auth.user?.id,
      id: id,
      type: type,
    })
    .then((response) => {
      window.open(response.data, "_blank");
    })
    .catch((error) => {
      Bugsnag.notify(error);
    });
};

const resendCertificate = async (id, type, date) => {
  eventBus.$emit(
    "CREATE_NOTIFICATION",
    "Resending certificates",
    "success",
    6500
  );
  await axios
    .put(`/api/send-certificate`, {
      id: id,
      type: type,
      date: date,
    })
    .then((response) => {
      Bugsnag.notify(response.data);
      eventBus.$emit(
        "CREATE_NOTIFICATION",
        "Successfully resend certificates",
        "success",
        6500
      );
      resending.value = false;
    })
    .catch((error) => {
      Bugsnag.notify(error);
      resending.value = false;
    })
    .finally(() => {
      resending.value = false;
    });
};

const fetchAssignPlaylist = async () => {
  await axios
    .get(`/api/fetchAssignedPlaylist`, {
      params: {
        type: "certified",
      },
    })
    .then((response) => {
      playlists.value = response.data;
    })
    .catch((error) => {
      Bugsnag.notify(error);
    });
};

fetchAssignPlaylist();

function downloadCertificate(id, type) {
  sendCertificate(id, type);
}

function resend(id, type, date) {
  resendCertificate(id, type, date);
}

function gotoUnit(unitId, playlistId = null) {
  if (playlistId) {
    router.push(`/units/${unitId}/${playlistId}`);
    return;
  }

  router.push(`/units/${unitId}`);
}

function closeNotificationDialog() {
  showNotificationDialog.value = false;
}

const fetchCertificates = async () => {
  loading.value = true;
  let param = props.user ? `/${props.user.user_id}` : "";
  await axios
    .get("/api/v3/user/my-progress/certificates-earned" + param)
    .then((response) => {
      courses.value = response.data.course_certificates;
      modules.value = response.data.module_certificates;
      playlists.value = response.data.playlist_certificates;
      loading.value = false;
    })
    .catch((error) => {
      Bugsnag.notify(error);
      loading.value = false;
    })
    .finally(() => {
      loading.value = false;
    });
};

onMounted(() => {
  fetchCertificates();
});

watch(showDialog, (value) => {
  if (value) {
    fetchCertificates();
  }
});
</script>
